import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { AppRemixIcon } from '@/layout/AppComponents';
import ReactDOMServer from 'react-dom/server';
import colors from '../../../../../../constants/colors';
import GGCLFavouriteObligation from './GGCLFavouriteObligation';
import Translator from '../../../../../components/helpers/Translator';
import GGCLStateHistory from './GGCLStateHistory';
import ObligationAssociation from './IconBlocks/ObligationAssociation';
import _ from 'lodash';

export default function GGCLIconListBlock(props) {
  const { obligationID } = props;
  const { moduleBridgeHex } = useParams();
  const poLevel2 = useSelector(
    (state) => state.currentPage?.obligationLevels?.level2
  );
  const poLevel3 = useSelector(
    (state) => state.currentPage?.obligationLevels?.level3
  );
  const permissions = useSelector(
    (state) => state.module[moduleBridgeHex].permissions
  );

  return (
    <>
      <GGCLFavouriteObligation
        isFavourite={poLevel2[obligationID]?.alerts?.isFavourite}
        obligationID={obligationID}
      />
      <AppRemixIcon
        icon="notification-2"
        title={ReactDOMServer.renderToString(
          poLevel2[obligationID]?.alerts?.modificationWarning ? (
            <Translator
              file="module-legalCompliance"
              name="obligation.modified"
              variables={{
                date: poLevel2[obligationID]?.alerts?.modificationWarning,
              }}
            />
          ) : (
            <Translator
              file="module-legalCompliance"
              name="obligation.without.modifications"
            />
          )
        )}
        color={
          poLevel2[obligationID]?.alerts?.modificationWarning
            ? colors.modifiedObligations
            : colors.grey300
        }
        filled={poLevel2[obligationID]?.alerts?.modificationWarning}
      />
      <GGCLStateHistory
        state={poLevel3?.[obligationID]?.stateHistory}
        obligationID={obligationID}
      />
      {poLevel2?.[obligationID]?.obligation?.applicableDate && (
        <AppRemixIcon
          icon="history"
          title={ReactDOMServer.renderToString(
            <Translator
              file="module-legalCompliance"
              name="applicable.from"
              variables={{
                applicableDate:
                  poLevel2?.[obligationID]?.obligation?.applicableDate,
              }}
            />
          )}
          color={colors.state2}
          filled
        />
      )}
      {permissions?.global?.corporateObligations &&
        poLevel3?.[obligationID]?.alerts?.corporateObligation && (
          <AppRemixIcon
            icon="building-4"
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-legalCompliance"
                name="corporate.obligation"
              />
            )}
            color={colors.danger}
            filled
          />
        )}
      {poLevel3 &&
        permissions?.ggcl?.showIconObligationAssociations &&
        permissions?.ggcl?.showIconObligationAssociations === true &&
        poLevel3[obligationID]?.showIconObligationAssociations &&
        poLevel3[obligationID]?.showIconObligationAssociations === true && (
          <ObligationAssociation
            description={poLevel3[obligationID].descriptionObligationAssociation ?? ''}
            obligationID={obligationID}
          />
        )}
      <div>
        {poLevel3 &&
          !_.isEmpty(poLevel3[obligationID]?.obligationGroupType1) && (
            <AppRemixIcon
              icon={poLevel3[obligationID]?.obligationGroupType1.icon}
              title={poLevel3[obligationID]?.obligationGroupType1.name}
              color={poLevel3[obligationID]?.obligationGroupType1.color}
              filled
              className="text-center"
            />
          )}
      </div>
      <div>
        {poLevel3 &&
          !_.isEmpty(poLevel3[obligationID]?.obligationGroupType2) && (
            <AppRemixIcon
              icon={poLevel3[obligationID]?.obligationGroupType2.icon}
              title={poLevel3[obligationID]?.obligationGroupType2.name}
              color={poLevel3[obligationID]?.obligationGroupType2.color}
              filled
              className="text-center"
            />
          )}
      </div>
    </>
  );
}
